import * as React from "react";
import { Box, Link, useTheme, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { isImage } from "./isImage";

export type FilePreviewProps = {
  paths: string[];
  setPaths: any;
  width?: string;
  height?: string;
  margin?: string;
};

export default function FilePreview(props: FilePreviewProps) {
  const { paths, setPaths, width, margin, height } = props;
  const theme = useTheme();

  const removePath = (path) => {
    setPaths(paths.filter((p) => p !== path));
  };

  const boxStyle = {
    maxHeight: "130px",
    backgroundColor: theme.palette.grey["100"],
    borderRadius: 1,
    padding: "7px",
    marginBottom: "16px",
    width: "fit-content",
    display: "inline-table",
  };

  return (
    <Box
      width={width}
      marginY={margin}
      height={height}
      overflow={"auto"}
      minWidth={"30vw"}
    >
      {paths.map((path, index) => {
        return (
          <Box key={index} sx={boxStyle}>
            {isImage(path) ? (
              <img
                src={`${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${path}`}
                alt=""
                style={{
                  objectFit: "contain",
                  maxWidth: "100%",
                  maxHeight: "100px",
                }}
                key={"img" + index}
              />
            ) : null}
            <Box display="flex" gap="15px" alignItems="center">
              <Link
                href={`${process.env.REACT_APP_AWS_CLOUDFRONT_URL}${path}`}
                key={index}
                underline="none"
                color={theme.palette.primary.main}
                target="_blank"
              >
                <Typography sx={{ overflow: "hidden" }}>
                  {path.split("/").slice(-1)}
                </Typography>
              </Link>
              <CloseIcon
                cursor="pointer"
                fontSize="small"
                onClick={() => removePath(path)}
              />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
